import { DatePicker, Divider, Button } from "antd";
import React from "react";

const PaySchedule = ({ onClose }) => {
  return (
    <div className="grid grid-cols-12 space-x-4 space-y-4">
      <div className="col-span-6   flex flex-col gap-1">
        <label htmlFor="salaryType" className="text-md">
          Pay Period
        </label>
        <select className="border px-2 py-1.5 rounded-md border-secondary text-md outline-none capitalize">
          <option value="">Select an option</option>
          <option value="permonth">per month</option>
          <option value="fortnightly">fortnightly</option>
        </select>
      </div>

      {/* period start */}
      <div className="col-span-6 flex flex-col gap-1">
        <label htmlFor="salaryType" className="text-md">
          Pay Period start date
          <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
        </label>
        <DatePicker onChange={() => {}} />
      </div>

      {/* name */}
      <div className="col-span-6 ">
        <label htmlFor="salaryType" className="text-md">
          Name <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
        </label>
        <input
          type="text"
          placeholder="Name"
          className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white w-full"
          //   onChange={handleChange}
          name="weekday_hourly_salary"
          //   value={form.weekday_hourly_salary}
        />
      </div>
      <div className="col-span-6 flex flex-col gap-1 ">
        <label htmlFor="salaryType" className="text-md">
          Pay Period end date
          <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
        </label>
        <DatePicker onChange={() => {}} />
      </div>
      <div className="col-span-6 flex flex-col gap-1 ">
        <label htmlFor="salaryType" className="text-md">
          If PayDay Fall On Holiday
        </label>
        <select className="border px-2 py-1.5 rounded-md border-secondary text-md outline-none capitalize">
          <option value="">Select an option</option>
          <option value="run payroll earlier">Run payroll earlier</option>
          <option value="run payroll later">Run payroll later</option>
        </select>
      </div>
      <div className="col-span-6 flex flex-col gap-1 ">
        <label htmlFor="salaryType" className="text-md">
          Pay Date
          <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
        </label>
        <DatePicker onChange={() => {}} />
      </div>
      <div className="col-span-12 flex items-center select-none">
        <input
          type="checkbox"
          className="mr-1"
          //   checked={form.exclude_payrol}
          //   onChange={handleChange}
          id="default"
        />
        <label htmlFor="default" className="text-md">
          Default
        </label>
      </div>

      <div className="col-span-12 flex items-center select-none">
        <input
          type="checkbox"
          className="mr-1"
          //   checked={form.exclude_payrol}
          //   onChange={handleChange}
          id="Is Hourly Pay"
        />
        <label htmlFor="Is Hourly Pay" className="text-md">
          Is Hourly Pay
        </label>
      </div>
      <Divider className="col-span-12 !p-0 !m-0" />
      <div className="col-span-12 flex items-center justify-end gap-3 my-3">
        <Button onClick={onClose} >Cancel</Button>
        <Button onClick={onClose} >OK</Button>
      </div>
    </div>
  );
};

export default PaySchedule;
